var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('x-query-builder',_vm._b({model:{value:(_vm.query),callback:function ($$v) {_vm.query=$$v},expression:"query"}},'x-query-builder',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }